import React from "react";
import "../css/SupportWallFooter.css";

const SupportWallFooter = () => {
  const shareUrl = "https://sahara.edu.np/fund-raising";
  const shareMessage =
    "Please support Sahara Public Secondary School's fund raising campaign:";

  const whatsappShare = `https://wa.me/?text=${encodeURIComponent(
    `${shareMessage} ${shareUrl}`,
  )}`;

  const linkedinShare = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    shareUrl,
  )}`;

  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareUrl,
  )}`;

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Sahara Public Secondary School",
          text: shareMessage,
          url: shareUrl,
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      window.open(whatsappShare, "_blank");
    }
  };

  const pricingTiers = [
    { amount: "₹500", label: "Cost of books for one student" },
    { amount: "₹1500", label: "School Uniform Set" },
    { amount: "₹5000", label: "Smart Lab Support" },
    { amount: "₹6000", label: "Smart Digital Board" },
  ];

  const wallOfFame = [
    {
      id: 1,
      name: "Vikram Rathore",
      tag: "Gold Member",
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
    },
    {
      id: 2,
      name: "Saira Bano",
      tag: "₹2,500 Donated",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&auto=format&fit=crop&q=80",
    },
    {
      id: 3,
      name: "Rohan Mehra",
      tag: "Monthly Donor",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&auto=format&fit=crop&q=80",
    },
    {
      id: 4,
      name: "Kavita Das",
      tag: "₹1,000 Donated",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
    },
  ];

  return (
    <div className="support-footer-master-container">
      {}
      <h2 className="section-main-heading-blue">Your Support, Their Success</h2>
      <div className="pricing-dashed-grid-system">
        {pricingTiers.map((tier, index) => (
          <div key={index} className="pricing-dashed-card-node">
            <h3>{tier.amount}</h3>
            <p>{tier.label}</p>
          </div>
        ))}
      </div>

      {}
      <h2 className="section-main-heading-blue space-top-layer">
        Our Wall of Fame 🏆
      </h2>
      <p className="section-subtitle-string">
        The people who sustained the dreams of our children.
      </p>

      <div className="wall-of-fame-profile-grid">
        {wallOfFame.map((donor) => (
          <div key={donor.id} className="donor-profile-white-card">
            <div className="avatar-gold-border-circle">
              <img
                src={donor.image}
                alt={donor.name}
                className="donor-img-element"
              />
            </div>
            <h4>{donor.name}</h4>
            <p className="donor-meta-tag-label">{donor.tag}</p>
          </div>
        ))}
      </div>

      {}
      <div className="transparency-footer-gray-panel">
        <div className="legal-left-info-block">
          <h5>Legal & Transparency</h5>
          <p>
            Sahara Public Secondary School is a registered non-profit
            organization. All donations are utilized solely for educational
            development.
          </p>
        </div>
        <div className="legal-right-links-matrix">
          <div className="links-col-node">
            <a href="#terms">Terms & Conditions</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
          <div className="links-col-node">
            <a href="#refund">Refund Policy</a>
            <a href="#certificate">80G Certificate</a>
          </div>
        </div>
      </div>

      {}
      <div className="social-action-buttons-flex-row">
        {}
        <a
          href={linkedinShare}
          target="_blank"
          rel="noopener noreferrer"
          className="social-pill-btn tw-color"
        >
          <svg
            className="social-svg-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
          Share on LinkedIn
        </a>

        {}
        <a
          href={facebookShare}
          target="_blank"
          rel="noopener noreferrer"
          className="social-pill-btn fb-color"
        >
          <svg
            className="social-svg-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c5.99 0 10.954-4.388 11.854-10.125h-8.385V7.078h3.47V4.031c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
          Share on Facebook
        </a>

        {}
        <a
          href="https://www.instagram.com/sahara.edu.np/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-pill-btn ig-color"
        >
          <svg
            className="social-svg-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0z" />
          </svg>
          Follow on Instagram
        </a>

        {}
        <a
          href={whatsappShare}
          target="_blank"
          rel="noopener noreferrer"
          className="social-pill-btn wa-color"
        >
          <svg
            className="social-svg-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M.057 24l1.687-6.163C.703 16.033.156 13.988.157 11.891.16 5.348 5.397 0 11.966 0c3.178.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.239 3.48 8.421-.003 6.615-5.34 11.962-11.91 11.962-2.006-.001-3.973-.509-5.717-1.474L0 24z" />
          </svg>
          Share on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default SupportWallFooter;
